import { useTranslation } from 'react-i18next';
import { PropertyListingPage } from '@/components/property/PropertyListingPage';
import { SEOHead } from '@/components/SEOHead';

export default function Rent() {
  const { t } = useTranslation();
  return (
    <>
      <SEOHead
        title="Properties for Rent in Ethiopia — Apartments & Houses"
        description="Find rental properties in Addis Ababa and across Ethiopia. Apartments, houses, villas and furnished units available for monthly and yearly rent."
        canonical="/rent"
      />
      <PropertyListingPage listingType="rent" titleKey={`${t('nav.rent')} — Properties for Rent`} />
    </>
  );
}
